import { Component } from '@angular/core';


@Component({
    selector: 'soft-sale-card',
    imports: [],
    templateUrl: './sale-card.component.html',
    styleUrl: './sale-card.component.css'
})
export class SaleCardComponent {}
